<template>
    <notice-details
        :item="noticeItem"
        :ori="props.ori"
        :notification="selectedNotification"
        :show-notice-details-modal="noticeDetailsModal"
        @dismiss="handleModalDismiss"
        @submit="handleModalDismiss"></notice-details>
    <b-card
        header="Notices"
        v-if="noticeStore.items.length">
        <b-table
            :items="noticeStore.items"
            :columns="columns"
            :caption="'Notices List'"
            aria-label="Notices List"
            :value="tableOptions">
            <template #cell.actions="{item}">
                <button
                    type="button"
                    class="btn btn-link ps-0"
                    @click.prevent="handleViewDetailsClick(item)"
                    :aria-label="`View details for notice ${item.header}`">
                    View Details
                </button>
            </template>
        </b-table>
        <div class="text-end">
            <a
                class="btn btn-primary"
                :href="`Notices.aspx`"
                aria-label="View all notices"
                >View All</a
            >
        </div>
    </b-card>
</template>
<script setup lang="ts">
import {reactive, ref, watch} from "vue";
import type {BTableColumn, BTableOptions} from "../BTable/BTable.types";
import {BCard} from "./../Misc";
import BTable from "../BTable/BTable.vue";
import {useNoticeStore} from "@/stores/noticeStore";
import hasPermission from "@/composable/permissionHelper";
import NoticeDetails from "../Notices/NoticeDetails.vue";
import {NoticeItem} from "../Notices/types";
import InformationModal from "../Misc/InformationModal.vue";
import {Notice} from "../../types";
import {AxiosResponse} from "axios";

const props = defineProps({
    ori: {
        type: String,
        default: null,
    },
});

const tableOptions: BTableOptions = {
    itemsPerPage: Number.MAX_SAFE_INTEGER,
    page: 1,
    sortBy: [],
    totalItemCount: 0,
    pagingMode: "noTotal",
};

const columns = reactive<BTableColumn[]>([
    {
        key: "date",
        text: "Date",
        sortable: false,
        columnClass: ["align-top"],
        value: (item) => item.send_date,
    },
    {
        key: "header",
        text: "Headline",
        sortable: false,
        columnClass: ["align-top"],
        value: (item) => item.header,
    },
    {
        key: "actions",
        text: "Actions",
        sortable: false,
        columnClass: ["align-top text-end"],
        class: (item) => ["text-end"],
        value: (item) => 1,
    },
]);

const noticeStore = useNoticeStore();
var noticeDetailsModal = ref(false);
var noticeItem = ref({} as NoticeItem);
var selectedNotification = ref({} as Notice);

function handleModalDismiss() {
    noticeDetailsModal.value = false;
}

function handleViewDetailsClick(item: Notice) {
    selectedNotification.value = item;
    noticeStore.getNoticeLog(item.NotificationLogId).then((response: AxiosResponse) => {
        if (response.status == 200 && response.data != undefined) {
            noticeItem.value = response.data;
            noticeDetailsModal.value = true;
        }
    });
}

watch(props, async () => {
    if (hasPermission("NoticesMainPage")) {
        await noticeStore.list(props.ori);
    }
});
</script>
